import React, { useMemo, useState } from "react";
import { IonBadge, IonChip, IonImg, IonItem, IonLabel, IonThumbnail } from "@ionic/react";
import sitePhotoService from "../SitePhotoService";
import { SitePhotoInfo } from "./SitePhotosList";
import moment from "moment";
import { User } from "../models/User";

interface Props {
    sitePhoto?: SitePhotoInfo;
    onClick: (filePath: string) => void;
    createdBy?: User;
}

const SitePhotoItem: React.FC<Props> = ({ sitePhoto, onClick, createdBy }) => {
    const [expanded, setExpanded] = useState(false);
    const maxChars = 60;
    const moreLabel = "more";
    const lessLabel = "less";

    const truncated = useMemo(() => {
        if (!sitePhoto?.comments) return "";

        if (sitePhoto.comments.length <= maxChars) return sitePhoto.comments;
        const slice = sitePhoto.comments.slice(0, maxChars);
        const cut = slice.replace(/\s+\S*$/, ""); // drop last partial word
        return cut || slice; // fallback if no space found
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [sitePhoto?.comments, maxChars]);

    const needsTruncate = sitePhoto ? sitePhoto.comments?.length > maxChars : false;

    const onToggle = (e: any) => {
        e.stopPropagation(); // don't trigger IonItem onClick/navigation
        setExpanded((v) => !v);
    };

    return (
        <>
            {sitePhoto && (
                <IonItem onClick={() => onClick(sitePhoto.filePath.toString())}>
                    <IonThumbnail slot="start">
                        <IonImg src={sitePhoto.filePath.toString()} />
                    </IonThumbnail>

                    <IonLabel>
                        <IonBadge
                            style={{
                                minHeight: "0px",
                                padding: "0px 5px",
                                margin: "0px",
                            }}
                            color={sitePhotoService.getSitePhotoTypeColor(sitePhoto.type.key)}
                        >
                            {sitePhoto.type.name}
                        </IonBadge>

                        {sitePhoto.dateCreated &&
                            " " +
                                moment(sitePhoto.dateCreated).format("L") +
                                (createdBy ? " by " + createdBy.firstName + " " + createdBy.lastName : "")}

                        <p>
                            {sitePhoto.comments &&
                                (!needsTruncate ? (
                                    sitePhoto.comments
                                ) : expanded ? (
                                    <>
                                        {sitePhoto.comments}{" "}
                                        <IonChip
                                            color={"dark"}
                                            onClick={onToggle}
                                            style={{
                                                minHeight: "0px",
                                                padding: "0px 5px",
                                                margin: "0px",
                                                backgroundColor: "transparent",
                                            }}
                                        >
                                            {lessLabel}
                                        </IonChip>
                                    </>
                                ) : (
                                    <>
                                        {truncated}
                                        {"… "}
                                        <IonChip
                                            color={"dark"}
                                            onClick={onToggle}
                                            style={{
                                                minHeight: "0px",
                                                padding: "0px 5px",
                                                margin: "0px",
                                                backgroundColor: "transparent",
                                            }}
                                        >
                                            {moreLabel}
                                        </IonChip>
                                    </>
                                ))}
                        </p>
                    </IonLabel>
                </IonItem>
            )}
        </>
    );
};

export default SitePhotoItem;
